var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "handle-click",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "handle-click",
    y: 0.319153,
    width: 27,
    height: 26,
    rx: 4.50597,
    fill: "#E9F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "handle-click",
    d: "M9.65977 15.9931L16.5817 9.07115L15.6166 8.1061L8.69471 15.028V15.9931H9.65977ZM10.2256 17.3581H7.32971V14.4622L15.1341 6.65783C15.2621 6.52989 15.4357 6.45801 15.6166 6.45801C15.7976 6.45801 15.9712 6.52989 16.0992 6.65783L18.0299 8.58863C18.1579 8.71661 18.2298 8.89018 18.2298 9.07115C18.2298 9.25213 18.1579 9.42569 18.0299 9.55368L10.2256 17.3581ZM7.32971 18.7231H19.6147V20.0881H7.32971V18.7231Z",
    fill: "#0869FB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.399b44266f22743f63b4c3fa3aa8910b.svg";
export { ForwardRef as ReactComponent };